import React, { useState, useEffect } from "react";
import { ReactSlider } from 'react-slider-image-js'
import 'react-slider-image-js/dist/index.css'
import $ from 'jquery';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import {MDBInput, MDBTable, MDBTableHead, MDBTableBody} from "mdb-react-ui-kit";
import "../../Componentes/www/style.css";
import { roundNumber } from "../Util";
import { Container, Row, Col, Label } from "reactstrap";
import {reactLocalStorage} from 'reactjs-localstorage';
import { LOGO, YAPPY_IMAGE_PUBLICIDAD } from "../Image";
 import {get_img_publicidad, imgURLLocalImageIp} from "./../Services";
var x = reactLocalStorage.getObject('tokenP');

export const SegundaPantalla = () => {
    const [dataPublicidad, setDataPublicidad] = useState([]);
    const [flagYappy, setFlagYappy] = useState(false);
    const [flagDatos, setFlagDatos] = useState(false);
    const [storage, setDataStorage] = useState([]);

  async function fetchPublicidad() {
    var response;
    response = await get_img_publicidad();
  
    var ObjItems=[];
    response.map((data)=>{
      ObjItems.push({
        src: imgURLLocalImageIp+data.img_name
      });
      return null;
    })
    setDataPublicidad(ObjItems);
  }

  async function fetchStorage() {
    x = reactLocalStorage.getObject('tokenP');

    setDataStorage(x)
    if(x.dataFacturaDetallePr.dataFacturaDetalle !== undefined){
      setFlagDatos(true)
    }
    else{
      setFlagDatos(false)
    }

    if( x.dataFacturaDetallePr[0] !== undefined){
      var xx=false;
      x.dataFacturaDetallePr.dataListPago.find((data,i)=>{
        if(data.list_fpagoName==="PAGO POR YAPPY"){
           xx = true;
          return true
        }
        else
          return null
      })
    }
 if(xx){
      setFlagYappy(true);
 }
 else{
  setFlagYappy(false);
 }
   
    setTimeout(() => {
      fetchStorage();
    }, 2000);
  }

  useEffect(() => {
    fetchPublicidad();
    fetchStorage();
  }, []);

  var descuento = 0;
  var subtotal = 0;
  var itbms = 0;
  var total = 0;
  if(flagDatos){
    storage.dataFacturaDetallePr.dataFacturaDetalle.map((row) => {
      descuento = Number(descuento) + Number(Number(row.fcd_descuento));
      subtotal = Number(subtotal) + Number(Number(row.fcd_total) - Number(row.fcd_itbms));
      itbms = Number(itbms) + Number(row.fcd_itbms);
      total =   Number(total) +Number(row.fcd_total);
      return null;
    });
  }
  if(flagDatos){
console.log(storage.dataFacturaDetallePr.dataFacturaDetalle);
  }

subtotal = roundNumber(subtotal,2);
itbms = roundNumber(itbms,2);
total = roundNumber(total,2);
$(document).ready(function() {
  $('.top-v').animate({
      scrollTop: $('.top-v').get(0).scrollHeight
  }, 600);
});
  return (
    <Container fluid>
      <Row>
        <Col xs={5} className="mx-auto text-center react-slider margin-padding-u div-slider">
            { dataPublicidad[0] !== undefined?
            <ReactSlider
            sliderIndex={0}
            images={dataPublicidad}
            slideAnimationDuration={'600ms'}
            imageBackgroundColor={'rgba(0, 0, 0, 0.9)'}
            objectFit={`fill`}
            isAutoSlide={true}
            autoSlideDuration={15000}
          />:<img src={LOGO} className="preview-img" alt="..." />}
        </Col>
        <Col xs={7} className="total-box">
        <Row>
            <Col xs={12} className="text-segunda ">
            {  flagDatos ? <><Label className="margin-padding-u">CLIENTE: {storage.dataFacturaDetallePr.formClientes.cli_nombre}</Label><br></br><Label className="margin-padding-u">RUC: {storage.dataFacturaDetallePr.formClientes.cli_ruc} {" DV: "} {storage.dataFacturaDetallePr.formClientes.cli_dv}</Label><br></br><Label className="margin-padding-u">EMAIL: {storage.dataFacturaDetallePr.formClientes.cli_email}</Label></>:<><Label className="margin-padding-u">CLIENTE: </Label><br></br><Label className="margin-padding-u">RUC: </Label><br></br><Label>EMAIL: </Label></>}   
            </Col>
            <Col xs={12} className="top-v padding-u">
            <MDBTable striped className="custom-table">
            <MDBTableHead dark>
            <tr className="fixed-header header-table-segunda-pantalla">
                <th className="text-center width-125px">CÓDIGO</th>
                <th className="text-center">DESCRIPCIÓN</th>
                <th className="text-center width-100px">PRECIO</th>
                <th className="text-center width-125px">CANTIDAD</th>
                <th className="text-center width-100px">DESC.</th>
                <th className="text-center width-100px">TOTAL</th>
            </tr>
            </MDBTableHead>
            <MDBTableBody className="scrolls">
            {  flagDatos?
                storage.dataFacturaDetallePr.dataFacturaDetalle.map((data, i) => {
                return <tr key={i}>
                    <td><b>{data.art_upc}</b></td>
                    <td>{data.art_descripcion}</td>
                    <td className="text-center">{Number(data.fcd_precio).toFixed(2)}</td>
                    <td className="text-center">{Number(data.fcd_cantidad).toFixed(0)}</td>
                    <td className="text-center">{data.fcd_descuento_number.length>0?Number(data.fcd_descuento).toFixed(2):""}</td>
                    <th className="text-center"><b>{Number(data.fcd_total).toFixed(2)}</b></th>
                </tr>
                }):""
            }
            </MDBTableBody>
        </MDBTable>
            </Col>
            <Col xs={12} className="botton-v">
            <Row>
            <Col xs={7} className="text-end"> {flagYappy?<img src={YAPPY_IMAGE_PUBLICIDAD} className="preview-img-3" alt="..." />:<img src={LOGO} className="preview-img-2" alt="..." />}</Col>
                <Col xs={5}>
                <Row>
                  <Col xs={12}>
                  <MDBInput
                        className="input-iventario-totales3"
                        id="subtotal"
                        wrapperClass="mb-2"
                        label="SUBTOTAL"
                        name="subtotal"
                        value={Number(total-itbms-descuento).toFixed(2)}
                        disabled={true}
                    />
                  </Col>
                  <Col  xs={12}>
                  <MDBInput
                        className="input-iventario-totales3"
                        id="descuento"
                        wrapperClass="mb-2"
                        label="DESCUENTO"
                        name="descuento"
                        value={Number(descuento).toFixed(2)}
                        disabled={true}
                    />
                  </Col>
                  <Col  xs={12}>
                  <MDBInput
                        className="input-iventario-totales3"
                        id="itbms"
                        wrapperClass="mb-2"
                        label="ITBMS"
                        name="descuento"
                        value={Number(itbms).toFixed(2)}
                        disabled={true}
                    />
                  </Col>
                  <Col  xs={12}>
                  <MDBInput
                        className="input-iventario-totales3"
                        id="total"
                        wrapperClass="mb-2"
                        label="TOTAL"
                        name="total"
                        value={Number(total).toFixed(2)}
                        disabled={true}
                    />
                  </Col>
                </Row>
                </Col>
            </Row>
            </Col>
        </Row>
        </Col>
      </Row>
    </Container>
  );
};
